import React from 'react'

import { NavLink } from 'react-router-dom'

import style from './TaskItem.module.css'

import { Task } from 'data/categories'

type PropsType = {
  task: Task
}

export const TaskItem = ({ task }: PropsType) => {
  return (
    <li className={style.item}>
      <NavLink className={style.link} to={`/simulator/${task.id}`}>
        {task.title}
      </NavLink>
    </li>
  )
}
